module.exports = __webpack_public_path__ + "static/img/icons-arrow-1-right.a24770f2.svg";